import bluebird from 'utils/bluebird';

import { call } from '../xmAPI';

export const NEXT_BASE = 'PLAN_INTEGRATION_LOGS_NEXT';
export const NEXT_START = `${NEXT_BASE}_START`;
export const NEXT_SUCCESS = `${NEXT_BASE}_SUCCESS`;
export const NEXT_FAIL = `${NEXT_BASE}_FAIL`;

export function getNext(uriList) {
  return dispatch => {
    dispatch({
      type: NEXT_START,
    });

    return bluebird
      .map(uriList, call)
      .then(payload => {
        dispatch({
          type: NEXT_SUCCESS,
          payload,
        });
      })
      .catch(err => {
        dispatch({
          type: NEXT_FAIL,
          payload: err,
        });
      });
  };
}
